<template>
  <div id="PrintSessionView3">
    <div v-if="PrintSessionShow" class="well" style="padding: 0 1em">
      <br style="text-align: left; padding: 0.5rem 2rem">
        <div style="display: flex">
          <div style="margin-right: 10px">
            活動開始日期：<br />
            <flat-pickr
              v-model="queryInfo.sActiveTime"
              :config="flatpickrConfig"
              ref="flatpickrInstance"
            ></flat-pickr>
          </div>

          <div>
            活動結束日期：<br />
            <flat-pickr
              v-model="queryInfo.eActiveTime"
              :config="flatpickrConfig"
              ref="flatpickrInstance"
            ></flat-pickr>
          </div>
          <div>

            <select v-model="queryInfo.options1Value">
              <option selected="selected" value="">請選擇</option>
              <option
                v-for="item in options1"
                :key="item.value"
                :value="item.value"
              >
                {{ item.text }}
              </option></select
            ><br />
          </div>

          <div>
            宣導人員：<br />
            <input
              type="text"
              class="form-control"
              v-model="queryInfo.updateUserName"
              placeholder="宣導人員"
            />
          </div>
          <button
            href="#"
            @click.prevent="getALLSessionList6()"
            class="btn btn-outline-info"
            type="button"
            style="font-size: 14px"
          >
            查詢
          </button>
          <button
            href="#"
            @click.prevent="reset()"
            class="btn btn-outline-info"
            type="button"
            style="font-size: 14px"
          >
            清除重來
          </button>

          <a
            style="margin: 0 0.5rem; text-decoration: none"
            target="_blank"
            tabindex="4"
            class="ncut-excel-style"
            :href="
              './WebApi/HighSchoolEnrolling/GetSessionXLSX6/'
                .concat(queryInfo.sActiveTime)
                .concat('/')
                .concat(queryInfo.eActiveTime)
                .concat('/')
                .concat(queryInfo.options1Value)
                .concat('/')
                .concat(queryInfo.updateUserName)
            "
            v-show="total > 0"
          >
            <img src="@/assets/images/ods-file24.png" style="height: 0.8rem" />
            {{ $t("message.Excel_txt") }}
          </a>
        </div>
        活動日期起迄：{{ queryInfo.sActiveTime + "-" + queryInfo.eActiveTime }}<br>
        目前高中職招生宣導活動共 {{ total }}筆
      </div>

      <b-tabs
        v-model="currentPage"

        content-class="mt-3"
        justified
      >
        <b-tab title="個人查詢" >
          <div
            class="dataTables_scrollBody"
            style="
              font-size: 14px;
              position: relative;
              overflow: auto;
              max-height: 100%;

              border-bottom: 1px solid #111;
              border-top: 1px solid #111;
            "
          >
            <b-table-simple
              title="queryInfo.options1Value"
              class="ncut-table-menu-striped ncut-table-menu"
              responsive
              bgcolor="#FFFFFF"
            >
              <b-thead class="ncut-thead-menu">
                <b-tr >
                  <th style="min-width: 2em">序號</th>
                  <b-th style="min-width: 2em">活動日期</b-th>
                  <b-th style="min-width: 2em">活動時間</b-th>
                  <b-th style="min-width: 2em">活動名稱</b-th>
                  <b-th style="min-width: 2em">班級</b-th>
                  <b-th style="min-width: 2em">集合時間(統一出發)</b-th>
                  <b-th style="min-width: 2em">集合地點(統一出發)</b-th>
                  <b-th style="min-width: 2em">集合時間(自行前往)</b-th>
                  <b-th style="min-width: 2em">集合地點(自行前往)</b-th>
                  <b-th style="min-width: 2em">交通方式</b-th>
                  <b-th style="min-width: 2em">司機姓名</b-th>
                  <b-th style="min-width: 2em">聯絡電話</b-th>
                  <b-th style="min-width: 2em">車牌號碼</b-th>
                  <b-th style="min-width: 2em">小組長手機號碼</b-th>
                  <b-th style="min-width: 2em">經費來源</b-th>
                </b-tr>
              </b-thead>
              <b-tbody class="ncut-tbody-menu">
                <b-tr v-for="(data, i) in inputData" :key="i" :index="i">
                  <b-td style="text-align: center">
                    {{
                      i+1
                    }}</b-td
                  >
                  <b-td style="text-align: center">
                    {{ data.sActiveTime }}
                  </b-td>

                  <b-td style="text-align: center">
                    {{ data.eActiveTime }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ data.activeName}}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ data.className }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ data.schoolGatherTime }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ data.schoolGatherPlace }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ data.goBySelfGatherTime }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ data.goBySelfGatherPlace }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ data.carClass }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ data.driverName }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ data.driverPhone }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ data.licensePlate  }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ data.enrollName + "/" +   data.enrollPhone}}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ data.budgetArrayString  }}
                  </b-td>

                </b-tr>
              </b-tbody>
            </b-table-simple>
            <b-pagination
            v-model="currentPage"
            :total-rows="total"
            :per-page="pageSize"
            :limit="21"
            v-if="total > pageSize"
          />
          </div>
        </b-tab>
      </b-tabs>
    </div>

</template>


<script>
import * as tools from "../tool";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { tw } from "flatpickr/dist/l10n/zh-tw.js";
export default {
  name: "PrintSessionView3",
  data() {
    return {
      sActiveTime:null,
      eActiveTime:null,
      ClassEnable: false,
      ForumEnable: false,
      ActiveName: null,
      selectedDateTime: null,
      TimeOpenShow: false,
      PrintSessionShow: false,
      options1Value: 1,
      options1: [{ value: 1, text: "個人查詢" }],
      cid: null,
      aid: null,
      sn: null,
      signUpID: null,
      today: null,
      signUpStatus: null,
      selected1: null,
      editId: 0,
      over: 0,
      total: 0,
      total2: 0,
      isIE: false,
      inputData: null,
      inputData2: null,
      flatpickrConfig: {
        allowInput: true, // 允許手動輸入
        clear: true, // 顯示清除按鈕
        defaultDate: "2024-01-01", // 清除當前選擇的日期
        enableTime: false,
        weekNumbers: true,
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "Y-m-d",
        time_24hr: false, // 這應該強制使用 12 小時制
        locale: {
          weekdays: {
            shorthand: ["日", "一", "二", "三", "四", "五", "六"],
            longhand: [
              "星期日",
              "星期一",
              "星期二",
              "星期三",
              "星期四",
              "星期五",
              "星期六",
            ],
          },
        },
      },
      inputData3: null,
      orglocalInputData3: null,
      localInputData3: null,
      selectedRowIndex: 0,
      currentPage: 1,
      currentPage2: 1,
      pageSize: 10,
      queryInfo: {
        sActiveTime: null,
        eActiveTime: null,
        schoolName: null,
        dptcdName: null,
        gidName: null,
        updateUserName: null,
        options1Value: 1,
      },
    };
  },
  components: {
    flatPickr,
  },
  methods: {
    // handleTabChange() {
    //   this.queryInfo.options1Value = this.currentPage + 1;

    //   this.getALLSessionList6();
    // },
    checkInput() {
      this.inputFlag = false;
      if (tools.empty(this.queryInfo.sActiveTime)) {
        alert("請選擇活動開始日期");
        this.inputFlag = true;
        return;
      }
      if (tools.empty(this.queryInfo.eActiveTime)) {
        alert("請選擇活動結束日期");
        this.inputFlag = true;
        return;
      }
         if (tools.empty(this.queryInfo.updateUserName)) {
        alert("請選擇宣導人員名稱");
        this.inputFlag = true;
        return;
      }

    },
    getActiveTime() {
      let vm = this;
      if (tools.empty(vm.queryInfo.sActiveTime)) {
        vm.queryInfo.sActiveTime = vm.flatpickrConfig.default;
      }
      if (tools.empty(vm.queryInfo.eActiveTime)) {
        vm.queryInfo.eActiveTime = vm.flatpickrConfig.default;
      }

      if (!tools.empty(vm.queryInfo.sActiveTime)) {
        const dateObject = new Date(vm.queryInfo.sActiveTime);
        // 提取日期部分
        vm.queryInfo.sActiveTime = dateObject.toISOString().split("T")[0];
      }
      if (!tools.empty(vm.queryInfo.eActiveTime)) {
        const dateObject = new Date(vm.queryInfo.eActiveTime);
        // 提取日期部分
        vm.queryInfo.eActiveTime = dateObject.toISOString().split("T")[0];
      }
    },
    reset() {
      let vm = this;
      vm.queryInfo = {
        sActiveTime: null,
        eActiveTime: null,
        schoolName: null,
        dptcdName: null,
        gidName: null,
        updateUserName: null,
        options1Value: 1,
      };
      vm.PrintSessionShow = true;

    },

    getALLSessionList6() {
      let vm = this;
      vm.checkInput();

      if (vm.inputFlag != true) {
      vm.currentPage = vm.queryInfo.options1Value - 1;
    //  vm.queryInfo.sActiveTime=vm.sActiveTime;
    //  vm.queryInfo.eActiveTime=vm.eActiveTime;
      vm.getActiveTime();
      this.$http
        .put("./WebApi/HighSchoolEnrolling/GetALLSessionList6/", vm.queryInfo)
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.inputData = response.data;
            vm.total = response.data.length;
            console.log("vm.inputData", vm.inputData);
          }
        })
        .catch(function (error) {
          alert("網路連線失敗" + error);
          // tools.showAlert(vm.inputData, "danger", "網路連線失敗" + error);
        });
    }
  },
  },

  created() {
    console.log("======created PrintSessionView3 =====");
    this.isIE =
      navigator.userAgent.indexOf("MSIE ") > -1 ||
      navigator.userAgent.indexOf("Trident/") > -1 ||
      navigator.userAgent.indexOf("Edge") > -1;
    let vm = this;

    vm.PrintSessionShow = true;
   // vm.getALLSessionList3();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
